import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { Navbar } from "../../Components/Navbar/Navbar";
import { Meta } from "../../Components/Helpers/Meta";
import { useParams } from "react-router-dom";
import InvestorSidebar from "../../Components/InvestorSidebar/InvestorSidebar";
import { LuDownload } from "react-icons/lu";
import "./CommitteesPage.style.css";

const CommitteesPage = () => {
  const { t } = useTranslation();
  const { lang } = useParams();
  const currentLang = i18next.language?.startsWith("tr") ? "tr" : "en";

  // Birden fazla komiteyi destekleyen veri yapısı
  const committees = [
    {
      id: "audit",
      title: { tr: "Denetim Komitesi", en: "Audit Committee" },
      headers: { left: { tr: "Başkan", en: "Chair" }, right: { tr: "Üye/Üyeler", en: "Member(s)" } },
      chair: { tr: "Ayşe Yılmaz", en: "Ayşe Yılmaz" },
      members: { tr: "Mehmet Kaya, Elif Demir", en: "Mehmet Kaya, Elif Demir" },
      charter: {
        name: {
          tr: "Denetim Komitesi Görev ve Çalışma Esasları",
          en: "Audit Committee Charter",
        },
        href: {
          tr: "https://www.cevher.com/static/docs/audit-charter-tr.pdf",
          en: "https://www.cevher.com/static/docs/audit-charter-en.pdf",
        },
      },
    },
    {
      id: "stratejic",
      title: { tr: "Strateji ve Dijitalleşme Komitesi", en: "Strategy and Digitalization Committee" },
      headers: { left: { tr: "Başkan", en: "Chair" }, right: { tr: "Üye/Üyeler", en: "Member(s)" } },
      chair: { tr: "Ayşe Yılmaz", en: "Ayşe Yılmaz" },
      members: { tr: "Mehmet Kaya, Elif Demir", en: "Mehmet Kaya, Elif Demir" },
      charter: {
        name: {
          tr: "Denetim Komitesi Görev ve Çalışma Esasları",
          en: "Audit Committee Charter",
        },
        href: {
          tr: "https://www.cevher.com/static/docs/audit-charter-tr.pdf",
          en: "https://www.cevher.com/static/docs/audit-charter-en.pdf",
        },
      },
    },
    // Yeni komite eklemek için aynı formatta obje ekle
  ];

  return (
    <div>
      <Meta
        title={t("committees-of-the-board-of-directors")}
        description={t("committees-of-the-board-of-directors")}
        lang={lang}
      />
      <Navbar />

      <div className="c-wrapper">
        {/* Hero (istersen mevcut görseli kullan) */}
        <div className="c-hero">
          <div className="c-hero-background">
            <picture>
              <img
                className="c-hero-image"
                alt=""
                src={require("../../assets/hero/public-offering.jpg")}
                style={{ width: "100%" }}
              />
            </picture>
          </div>
          <div className="c-hero-body">
            <div className="c-about-caption">
              <div className="c-caption-section" style={{ color: "#000", textAlign: "center" }}>
                {t("investor-relations")}
              </div>
              <h1 className="c-caption-header" style={{ color: "#000" }}>
                {t("committees-of-the-board-of-directors")}
              </h1>
            </div>
          </div>
        </div>

        {/* İçerik */}
        <div className="po-container">
          <InvestorSidebar />

          <main className="committees-content">
            {committees.map((c) => (
              <section key={c.id} className="committee-card">
                {/* Komite başlık satırı */}
                <div className="committee-title">{c.title[currentLang]}</div>

                {/* 2 sütun başlık */}
                <div className="committee-headrow">
                  <div className="committee-th">{c.headers.left[currentLang]}</div>
                  <div className="committee-th">{c.headers.right[currentLang]}</div>
                </div>

                {/* İsimler (doldurmadıysan boş da kalabilir) */}
                <div className="committee-datarow">
                  <div className="committee-td">{c.chair?.[currentLang] || ""}</div>
                  <div className="committee-td">{c.members?.[currentLang] || ""}</div>
                </div>

                {/* Charter satırı: metin + sağda indirme */}
                <div className="committee-charter">
                  <span className="committee-charter-title">
                    {c.charter.name[currentLang]}
                  </span>
                  <a
                    href={c.charter.href[currentLang] || c.charter.href.en}
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Download committee charter"
                    className="committee-dl"
                  >
                    <LuDownload size={18} />
                  </a>
                </div>
              </section>
            ))}
          </main>
        </div>
      </div>
    </div>
  );
};

export default CommitteesPage;
